export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '1ae95086-39d3-4a8d-bb5b-ac83b26b74a4';
export const TENANT_ID = process.env.REACT_APP_TENANT_ID || 'a6b367ba-ec52-46fe-86eb-4eb23357a8ab';
export const TOKEN_SCOPE = process.env.REACT_APP_TOKEN_SCOPE || 'api://damage-portal-apis/.default';
